import React from 'react';
import PropTypes from 'prop-types';

import LoadingSpinnerIcon from '@icons/LoadingSpinnerIcon';
import { LoadingContainer } from '@styled';
import colors from '@general/colors';

const LoadingArea = ({ minHeight = 600, minHeightMobile = 300, style }) => (
    <LoadingContainer minHeight={minHeight} minHeightMobile={minHeightMobile} style={style}>
        <LoadingSpinnerIcon fill={colors.darkGray} />
    </LoadingContainer>
);

LoadingArea.propTypes = {
    minHeight: PropTypes.number,
    minHeightMobile: PropTypes.number,
    style: PropTypes.object,
};

export default LoadingArea;
